<div class="subBlockContainer">
  <div class="subBlockContent" id="upgradeSubscription">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <form [formGroup]="upgradeSubscriptionForm">

            <!-- SUBSCRIPTION DETAILS & MANAGE SERVICE -->
            <ng-container>
              <div class="row">
                <!-- left col SUBSCRIPTION DETAILS -->
                <div class="col-md-6"  *ngIf="!isSoftwareOrRI">
                  <div class="my-4">
                    <h6>SUBSCRIPTION DETAILS</h6>
                    <div class="my-4">
        
                      <div class="my-2">
                        MPN : 
                        <span class="red-bold">
                          {{from?.out_mpnid =='' ? NoMPNText : from?.out_mpnid}}
                        </span>
                        <i
                          style="margin: -10px 0 0 5px; position: absolute;"
                          class="basic-icon edit-icon cursor-pointer"
                          (click)="toggleMPNChange()"
                        ></i>
                      </div>
    
                      <div class="row">
                        <div class="col-6">
                          <mat-form-field *ngIf="editMpn" class="full-width my-4" appearance="fill" style="padding-left: 0px;">
                            <input
                              type="text"
                              placeholder="Change MPN"
                              aria-label="Number"
                              matInput
                              integerOnly
                              #trigger="matAutocompleteTrigger"
                              formControlName="mpn"
                              [matAutocomplete]="auto"
                            >
                            <i
                              *ngIf="upgradeSubscriptionForm.get('mpn').enabled"
                              class="material-icons align-arrow-right"
                              (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                            <mat-autocomplete #auto="matAutocomplete">
                              <mat-option [value]="NoMPNText">
                                {{NoMPNText}}
                              </mat-option>
                              <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                                {{mpn}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>
                        <mat-spinner
                          *ngIf="upgradeSubscriptionForm.get('mpn').disabled"
                          mode="indeterminate"
                          class="circle cSPCustomerEntitlements-loading"
                          style="position: relative;top:35px"
                          diameter="20">
                        </mat-spinner>
                      </div>
                      <div class="my-2">
                        DESC :<span class="red-bold">
                          {{from?.out_sub_description}}</span> <i style="margin: -10px 0 0 5px; position: absolute;"
                          class="basic-icon edit-icon cursor-pointer" (click)="toggleDescChange()"></i>
                      </div>
        
                      <div class="row">
                        <div class="col-6">
                          <mat-form-field *ngIf="editDesc" class="full-width my-4" appearance="fill" style="padding-left: 0px;">
                            <input
                              type="text"
                              placeholder="Change Description"
                              aria-label="Number"
                              matInput
                              #trigger="matAutocompleteTrigger"
                              formControlName="desc"
                              [matAutocomplete]="auto">
                            <i
                              *ngIf="upgradeSubscriptionForm.get('desc').enabled"
                              class="material-icons align-arrow-right"
                              (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
                            <mat-autocomplete #auto="matAutocomplete">
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>
                        <mat-spinner
                          *ngIf="upgradeSubscriptionForm.get('desc').disabled"
                          mode="indeterminate"
                          class="circle cSPCustomerEntitlements-loading"
                          style="position: relative;top:35px"
                          diameter="20">
                        </mat-spinner>
                      </div>
        
                      <div class="my-2">
                        STOCKCODE :<span class="red-bold"> {{from.out_stock_code}}</span> <br>
                      </div>
        
                    </div>
                  </div>
                </div>
                <!-- right col MANAGE SERVICE -->
                <div class="col-md-6" *ngIf="from?.out_charge_type=='NCE' || from?.out_stock_group === '85CU'">
                  <div class="my-4">
                    <h6>MANAGE SERVICE</h6>
                    <div class="my-4">
                      <span>This will suspend service, you will continue to accrue charges as per this subscriptions existing commitment. Additional commitments will also accrue if auto-renew is still enabled</span>
                    </div>
      
                    <div class="my-4">
                      <div style="display: inline-flex;">
                        <span class="highlight-text">SERVICE STATUS : </span>
                        <span> {{this.from.out_status_desc}} </span>
                        <mat-slide-toggle
                          style="margin-top: -4px;"
                          [disableControl]="
                            autoRenewLoading ||
                            !isRenewLoaded ||
                            this.from.out_status_desc == 'Pending Creation' ||
                            !currentUser?.hasAdminAccess && !currentUser?.hasPurchaseAccess
                          "
                          [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"  
                          matTooltip="Requires Purchasing Permissions"
                          formControlName="activeSuspend"
                          (change)="toggleSuspendHandler()"
                          class="activesuspend mx-4">
                        </mat-slide-toggle>
                        <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                          class="circle cSPCustomerEntitlements-loading" diameter="20"
                          *ngIf="autoRenewLoading || !isRenewLoaded">
                        </mat-spinner>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
              </div>
                    
              <div class="mt-4" *ngIf="!isSoftwareOrRI" style="display: flex;justify-content: center;">
                <button class="button button-red button-large"
                  [disabled]="((upgradeSubscriptionForm.get('mpn').value == from.out_mpnid) && (upgradeSubscriptionForm.get('desc').value == from.out_sub_description))"
                  (click)="updateSubscriptionDetails()">SAVE DETAILS
                </button>
  
                <button *ngIf="isCancelable" class="button button-red button-large"
                  (click)="cancelSubscription(from)"
                  [disabled]="isCanceling || (!currentUser?.hasAdminAccess && !currentUser?.hasPurchaseAccess)"
                  [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"  
                  matTooltip="Requires Purchasing Permissions"
                  >Cancel Subscription
                </button>
                <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                  style="position: relative;top:15px" *ngIf="isCanceling">
                </mat-spinner>
                <hr>
              </div>
            </ng-container>

            <!-- MANAGE RENEWAL -->
            <ng-container *ngIf="from?.out_stock_group !== '85CU'">
              <h6>MANAGE RENEWAL</h6>
              <div *ngIf="renewalIsToday">
                <span class="red-bold">This subscription is being actively renewed. Updating auto renew, scheduling changes, and suspending is not available. All other actions will continue to work normally. Subscriptions may take up to 24 hours to complete their renewal</span>
              </div>
              <div class="row">
                <!-- left col -->
                <div class="col-md-6">
                  <div class="my-4">
                    <span>Changes will take effect on renewal date: {{getRenewDate()}}</span> <br>
                    <span>
                      Quantity increase and Upgrade will be effective instantly
                    </span>
                  </div>
    
                  <div class="mt-4" *ngIf="isSubInProgress()">
                    <span class="highlight-text">STATUS : <span style="text-transform: uppercase;"
                        class="red-bold">{{from.out_status_desc}}</span><br>
                    </span>
                  </div>
    
                  <div class="my-4">
    
                    <div style="display: inline-flex;">
                      <span class="highlight-text">AUTORENEW: </span>
                      <mat-slide-toggle
                        style="margin-top: -4px;"
                        formControlName="autoRenewalEnabled"
                        [disableControl]="
                          autoRenewLoading ||
                          !isRenewLoaded ||
                          (!isSoftwareOrRI && !from.out_activeSuspend) ||
                          renewalIsToday ||
                          (!currentUser?.hasAdminAccess && !currentUser?.hasPurchaseAccess)
                        "
                        [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"    
                        matTooltip="Requires Purchasing Permissions"
                        (change)="toggleAutoRenew($event, from)"
                        class="activesuspend mx-4">
                      </mat-slide-toggle>
                      <span *ngIf="isRenewLoaded">{{getAutoRenwewalText(upgradeSubscriptionForm.get('autoRenewalEnabled').value)}}</span>
                      <span *ngIf="isRenewLoaded && !upgradeSubscriptionForm.get('autoRenewalEnabled').value">, Auto renew must be enabled to change TERM & BILLING
                        FREQUENCY</span>
                      <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                        class="circle cSPCustomerEntitlements-loading" diameter="20"
                        *ngIf="autoRenewLoading || !isRenewLoaded">
                      </mat-spinner>
                    </div>
                  </div>
    
                  <!-- QUANTITY-->
                  <div class="my-4">
    
                    <div>
                      <span> <span class="highlight-text">QUANTITY: </span> CURRENT : {{qty}}</span>
                    </div>
    
                    <ng-container *ngIf="!isSoftwareOrRI">
                      <div class="my-2">
                        <span>CHANGE TO:</span>
                      </div>
        
                      <div class="my-2">
                        <div>
                          <input
                            type="number"
                            aria-label="Number"
                            formControlName="toQty"
                            [disableControl]="(!isRenewLoaded && upgradeSubscriptionForm.get('toQty').value) || !currentUser?.hasPurchaseAccess"
                            (keypress)="onQtyTyping($event)"
                            (blur)="updateQty()"
                            integerOnly
                          >
                          <span class="ml-2">
                            <a
                              *ngIf="refundableQuantity?.details.length > 0"
                              class="result_desc"
                              style="cursor: pointer;"
                              placement="bottom"
                              [ngbTooltip]="CancellationList"
                              #t="ngbTooltip"
                            >
                              View Refundable Licenses
                            </a>
                          </span>
                          <ng-template #CancellationList>
                            <div *ngIf="cancellationContent != null && cancellationContent.totalQuantity" class="d-flex flex-column" style="text-align: left;">
                              <span>Total Refundable Quantity: {{cancellationContent.totalQuantity}}*</span>
                              <br />
                              <span *ngFor="let c of cancellationContent.details">{{c}}</span>
                              <br />
                              <span>*Prorated charges may apply after 24 hrs</span>
                            </div>
                          </ng-template>
                          
                          <span class="ml-2">
                            <a
                              *ngIf="isScheduleChanege()"
                              class="result_desc"
                              style="cursor: pointer;"
                              placement="bottom"
                              [ngbTooltip]="ScheduleChangesUpdate"
                              #t2="ngbTooltip"
                            >
                              <span class="small-logo-wrapper">
                                <img style="width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                              </span>
                              Scheduled Changes
                            </a>
                          </span>
                          <ng-template #ScheduleChangesUpdate>
                            <div class="d-flex flex-column" style="text-align: left;">
                              <span>Scheduled Changes for next renewal</span>
                              <br />
                              <span>Quantity: {{ nceRenewalPending?.quantity || scheduledNextTermInstructions?.quantity }}</span>
                              <span>SKU: {{ nceRenewalPending?.stockCode.toUpperCase() || (scheduledNextTermInstructions?.product?.termDuration + ':' + scheduledNextTermInstructions?.product?.productId + ':' + scheduledNextTermInstructions?.product?.skuId)}}</span>
                              <span *ngIf="scheduledNextTermInstructions?.product?.billingCycle">Billing cycle: {{ scheduledNextTermInstructions?.product?.billingCycle }}</span>
                              <span>Term: {{ cs.getTermDisplay(nceRenewalPending?.term || scheduledNextTermInstructions?.product?.termDuration) }}</span>
                              <span *ngIf="scheduledNextTermInstructions?.customTermEndDate">End Date Alignment: {{ scheduledNextTermInstructions?.customTermEndDate |  date: 'dd/MM/yyyy' }}</span>
                            </div>
                          </ng-template>
                        </div>
  
  
                        <!-- <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                          *ngIf="qtyLoading">
                        </mat-spinner> -->
                      </div>
                    </ng-container>
<!--                     
                    <div *ngIf="from?.out_charge_type=='NCE'" class="produc-secondary-title-wrapper pt-2">
                      <div style="margin-bottom: 0.5rem!important;">
                        <span>END DATE ALIGNMENT:&nbsp;&nbsp;&nbsp;</span>
                      </div>
                      <div class="custom-end-date">
                        <div class="searchIcon">
                          <img src="../images/new_ui/date.png">
                        </div>
                        <input class="custom-end-date-input" type="text" placeholder="Date" mame="shippingDate" ngbDatepicker
                          #dA="ngbDatepicker"formControlName="customEndDate" (click)="openRightPanel(tempRef)"
                          [minDate]="{year: calendar.getToday().year, month: calendar.getToday().month, day: calendar.getToday().day}" readonly>
                        <mat-icon matSuffix class="editmpnidicon" placement="bottom"
                          ngbTooltip="You can co-term your new NCE subscription to the same end date as any other NCE subscription already present on the tenant or align to calendar month.">
                          info</mat-icon>
                        
                        <span class="produc-secondary-title-wrapper">
                          <a
                            style="cursor: pointer;"
                            placement="bottom"
                            (click)="openRightPanel(tempRef)"
                          >
                            <span class="small-logo-wrapper">
                              <img src="../images/new_ui/clock-red.png">
                            </span>
                            View subscription end-dates
                          </a>
                        </span>
                        <mat-spinner style="margin-left: 10px;" mode="indeterminate"
                          class="circle cSPCustomerEntitlements-loading" diameter="20"
                          *ngIf="customEndDateLoading">
                        </mat-spinner>
     
                      </div>
                    </div> -->
                  </div>
                </div>
                <!-- right col -->
                <div class="col-md-6">
                  <!-- TERM DURATION-->
                  <div class="my-4" *ngIf="!isSoftwareOrRI">
  
                    <div>
                      <span> <span class="highlight-text">TERM :</span> Current :
                        {{ cs.CSPTermMapping(getCurrentTerm()) }}</span>                   
                    </div>
  
                    <div class="my-2">
                      <span>CHANGE TO:</span>
                    </div>
  
                    <div class="row">
                      <div class="col-md-8">
                        <mat-form-field appearance="fill" style="padding-left: 0px;">
                          <mat-select
                            formControlName="renewal"
                            [disableControl]="
                              isSubInProgress() ||
                              !isRenewLoaded ||
                              !upgradeSubscriptionForm.get('autoRenewalEnabled').value ||
                              !from.out_activeSuspend ||
                              renewalIsToday ||
                              renewalLoading
                            " >
                            <mat-option value="">No Change</mat-option>
                            <mat-option value="P1Y" *ngIf="getCurrentTerm() != 'P1Y'">Annual</mat-option>
                            <mat-option value="P1M" *ngIf="getCurrentTerm() != 'P1M'">Monthly</mat-option>
                            <!-- <mat-option value="P3Y" *ngIf="getCurrentTerm() != 'P3Y'">Triennial</mat-option> -->
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                        style="position: relative;top:15px" *ngIf="renewalLoading">
                      </mat-spinner>
                    </div>
                  </div>
  
                  <!-- Billing Freqency-->
                  <div class="my-4" *ngIf="!isSoftwareOrRI">
  
                    <div>
                      <span>
                        <span class="highlight-text">
                          BILLING FREQUENCY :
                        </span> 
                        <span>
                          Current : {{ billingCycle | titlecase}}
                        </span>
                        <!-- <span *ngIf="!billingCycleList?.length">
                          Billing Frequency Not Supported
                        </span> -->
                      </span>

                    </div>
  
                    <div class="my-2">
                      <span>CHANGE TO:</span>
                    </div>
  
                    <div class="row">
                      <div class="col-md-8">
                        <!-- For Subscription -->
                        <ng-container *ngIf="!isSoftwareOrRI">
                          <mat-form-field appearance="fill" style="padding-left: 0px;">
                            <mat-select formControlName="billing"
                              [disableControl]="
                                isSubInProgress() ||
                                !isRenewLoaded ||
                                !upgradeSubscriptionForm.get('autoRenewalEnabled').value ||
                                !from?.out_activeSuspend ||
                                billingLoading ||
                                isBillingFreq ||
                                renewalIsToday
                              ">
                              <mat-option value="">No Change</mat-option>
                              <ng-container *ngFor="let billingcycle of billingCycleList">                                
                                <mat-option [value]="cs.CSPBFMapping(billingcycle)">{{billingcycle}}</mat-option>
                              </ng-container>
                            </mat-select>
                            <span style="position:relative;">                                            
                              <mat-spinner mode="indeterminate" class="billingfreq" diameter="15"
                              *ngIf="isBillingFreq">  
                            </mat-spinner>
                          </span>
                          </mat-form-field>
                        </ng-container>
                        <!-- For Software -->
                        <!-- <ng-container *ngIf="isSoftwareOrRI">
                          <mat-form-field appearance="fill" style="padding-left: 0px;">
                            <mat-label>{{from.out_billing_freq == 'Y'?'Annual':'Monthly'}}</mat-label> 
                            <mat-select formControlName="billing"
                              [disableControl]="isSubInProgress() || !isRenewLoaded || !upgradeSubscriptionForm.get('autoRenewalEnabled').value">
                              <mat-option value="">
                                No Change</mat-option>
                                <ng-container *ngFor="let bcy of supportedBillingCycles">
                                  <mat-option  *ngIf="billingCycle !== bcy" value="{{bcy}}">{{bcy | titlecase}}</mat-option>
                                </ng-container>
                            </mat-select>
                          </mat-form-field>
                        </ng-container> -->
                      </div>
                     <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                        style="position: relative;top:15px" *ngIf="billingLoading">
                      </mat-spinner>
                    </div>
                  </div>

                  <!-- End Date Alignment-->
                  <div class="my-4" *ngIf="!isSoftwareOrRI && showEndDateAligment()">

                    <div>
                      <span> <span class="highlight-text">END DATE ALIGNMENT : </span> Current :
                        {{ expiryDate | date: 'dd/MM/yyyy' }}</span>
                    </div>
  
                    <div class="my-2">
                      <span>CHANGE TO:</span>
                    </div>
  
                    <div class="row">
                      <div class="col-md-8">
                        <ng-container>
                          <mat-form-field appearance="fill" style="padding-left: 0px;">
                            <mat-select
                              formControlName="customEndDateTypeControl"
                              class="customDropdwon"
                              bindValue="value"
                              bindLabel="displayText"
                              (selectionChange)="changeEndDate($event.value, tempRef)"
                              [disableControl]="
                                isSubInProgress() ||
                                !isRenewLoaded ||!upgradeSubscriptionForm.get('autoRenewalEnabled').value ||
                                !from.out_activeSuspend ||
                                renewalIsToday
                              "
                            >
                              <mat-option *ngFor="let type of customEndDateTypeList" [value]="type" >
                                {{ type }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="custom-end-date" *ngIf="this.upgradeSubscriptionForm.get('customEndDateTypeControl')?.value !== 'No Change'">
                            <div class="searchIcon">
                              <img src="../images/new_ui/date.png">
                            </div>
                            <input #customEndAateInput class="custom-end-date-input" type="text" placeholder="Date" mame="shippingDate" ngbDatepicker
                              #dA="ngbDatepicker" formControlName="customEndDate" (click)="openRightPanel(tempRef)"
                              readonly>
                            <mat-icon matSuffix class="editmpnidicon" placement="bottom"
                              ngbTooltip="You can co-term your new NCE subscription to the same end date as any other non-trial NCE subscription already present on the tenant or align to calendar month.">
                              info</mat-icon>
                            
                            <!-- ViewSubEndDate hover -->
                            <span class="produc-secondary-title-wrapper" *ngIf="this.upgradeSubscriptionForm.get('customEndDateTypeControl')?.value == 'Co-Term'">
                              <a
                                style="cursor: pointer;"
                                placement="bottom"
                                (click)="openRightPanel(tempRef)"
                              >
                                <span class="small-logo-wrapper">
                                  <img style="width: 16px; height: 16px;" src="../images/new_ui/clock-red.svg">
                                </span>
                                View subscription end-dates
                              </a>
                            </span>
                            <!-- view end dates right panel -->

                          </div>
                        </ng-container>
                        <!-- For Software -->
                     <!--  <ng-container *ngIf="isSoftwareOrRI">
                          <mat-form-field appearance="fill" style="padding-left: 0px;">
                         
                            <mat-select formControlName="billing"
                              [disableControl]="isSubInProgress() || !isRenewLoaded || !upgradeSubscriptionForm.get('autoRenewalEnabled').value">
                              <mat-option value="">
                                No Change</mat-option>
                                <ng-container *ngFor="let bcy of supportedBillingCycles">
                                  <mat-option  *ngIf="billingCycle !== bcy" value="{{bcy}}">{{bcy | titlecase}}</mat-option>
                                </ng-container>
                            </mat-select>
                          </mat-form-field>
                        </ng-container> -->
                      </div>
                      <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                        style="position: relative;top:15px" *ngIf="billingLoading">
                      </mat-spinner>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4" style="display: flex;justify-content: center;">
                <button
                  class="button button-red button-large"
                  [disabled]="
                    !from?.out_activeSuspend ||
                    !upgradeSubscriptionForm.get('autoRenewalEnabled').value ||
                    (!currentUser?.hasAdminAccess && !currentUser?.hasPurchaseAccess) ||
                    currentProductPricingV2?.out_condition == 'T' ||
                    (
                      !termChanged &&
                      !billingFreqChanged &&
                      !customEndDateChanged &&
                      !qtyChanged 
                    )
                  " 
                  (click)="updateRenewal()"
                  [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"  
                  matTooltip="Requires Purchasing Permissions"
                >
                  Schedule Subscription Renewal
                </button>
                <mat-spinner  *ngIf="loadingSKUStatus" mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="position: relative;top:15px"></mat-spinner>
                <ng-container *ngIf="currentProductPricingV2?.out_condition == 'T' && !transitionEligibilitiesScheduledLoaded" >
                  <button [disabled]="loadingTransitionEligibilitiesScheduled" class="button button-red button-large" (click)="renewalPaths()">
                    Renewal Paths
                  </button>
                </ng-container>

                <ng-container *ngIf="isSoftwareOrRI">
                  <button *ngIf="isCancelable" class="button button-red button-large" (click)="cancelSubscription(from)" [disabled]="isCanceling">Cancel</button>
                  <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20" style="position: relative;top:15px" *ngIf="isCanceling"></mat-spinner>
                </ng-container>
              </div>

              <div class="my-4" *ngIf="transitionEligibilitiesScheduledLoaded">
                <h6>RENEWAL OPTIONS (SCHEDULED)</h6>
              </div>

              <!-- scheduled eligibilities  -->
              <div class="mt-4">
                <div *ngIf="loadingTransitionEligibilitiesScheduled" >
                  <mat-spinner mode="indeterminate" diameter="20" style="margin:0 auto;"></mat-spinner>
                </div>
                <div *ngIf="!loadingTransitionEligibilitiesScheduled">
                  <div *ngIf="transitionEligibilitiesScheduledLoaded">
                    <label class="noData-wrapper" *ngIf="transitionEligibilitiesScheduledDisplay.length == 0">
                      We couldn’t find any transition eligibilities
                    </label>
      
                    <div *ngIf="transitionEligibilitiesScheduledDisplay?.length" class="mt-4">
                      <div class="child-body addaddon-table">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" class="align-left" style="width: 30%;">Stock Code</th>
                              <th scope="col" class="align-left" style="width: 30%;">Title</th>
                              <!-- <th scope="col" class="align-center" style="width: 20%;">Quantity</th> -->
                              <th style="width: 20%;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let transition of transitionEligibilitiesScheduledDisplay">
                              <tr>
                                <td style="width: 30%;">
                                  <span class="description-popup">{{transition?.catalogItemId | cspTransitionSkuPipe}}</span>
                                </td>
                                <td style="width: 30%;">
                                  <span class="description-popup">{{transition?.title}}</span>
                                </td>
                                <!-- <td class="align-center" style="position: relative;vertical-align: middle; width:20%">
                                <input class="align-center align-top input-wrapper input-wrapper-small"
                                  [(ngModel)]="transition.quantity" type="text" integerOnly>
                              </td> -->
                                <td style="width: 20%;" class="text-center">
                                  <button
                                    class="button button-red button-mid confirmbutton"
                                    [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"    
                                    matTooltip="Requires Purchasing Permissions"
                                    (click)="confirmTransition(transition, TransitionType.TRANSITION_WITH_LICENSE_TRANSFER)"
                                  >Renewal</button>
                                </td>
                              </tr>
                            </ng-container>
      
                          </tbody>
                        </table>
                      </div>
                      <div class="button-center">
                        <!--addonList and finishAddAddon method are not defined-->
                        <!-- <button *ngIf="addonList?.length && loadContent" class="button button-red button-large"
                          (click)="finishAddAddon()">Continue</button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!isSoftwareOrRI && from?.out_stock_group !== '85CU'">

              <hr>

              <!-- UPGRADE -->
              <div class="my-4">
                <!-- <span class="highlight-text mb-4">UPGRADE OPTIONS</span> <br> -->
                <h6>UPGRADE OPTIONS</h6>
              </div>


              <div class="mt-4">
                <div *ngIf="loadingTransitionEligibilities" >
                  <mat-spinner mode="indeterminate" diameter="20" style="margin:0 auto;"></mat-spinner>
                </div>
                <div *ngIf="!loadingTransitionEligibilities">

                  <!-- view button -->
                  <div *ngIf="!transitionEligibilitiesLoaded" class="mt-4" style="display: flex;justify-content: center;">
                    <button
                      class="button button-red button-large"
                      (click)="getTransitionEligibilities()"
                      [disabled]="(!tenantId && !subscriptionId)"
                    >
                      View Eligible Offers
                    </button>
                  </div>

                  <div *ngIf="transitionEligibilitiesLoaded">
                    <label class="noData-wrapper" *ngIf="transitionEligibilitiesDisplay.length == 0">
                      We couldn’t find any transition eligibilities
                    </label>
      
                    <div *ngIf="transitionEligibilitiesDisplay?.length" class="mt-4">
                      <div class="child-body addaddon-table">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col" class="align-left" style="width: 30%;">Stock Code</th>
                              <th scope="col" class="align-left" style="width: 30%;">Title</th>
                              <!-- <th scope="col" class="align-center" style="width: 20%;">Quantity</th> -->
                              <th style="width: 20%;"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let transition of transitionEligibilitiesDisplay">
                              <tr>
                                <td style="width: 30%;">
                                  <span class="description-popup">{{transition?.catalogItemId | cspTransitionSkuPipe}}</span>
                                </td>
                                <td style="width: 30%;">
                                  <span class="description-popup">{{transition?.title}}</span>
                                </td>
                                <!-- <td class="align-center" style="position: relative;vertical-align: middle; width:20%">
                                <input class="align-center align-top input-wrapper input-wrapper-small"
                                  [(ngModel)]="transition.quantity" type="text" integerOnly>
                              </td> -->
                                <td style="width: 20%;" class="text-center">
                                  <button
                                    class="button button-red button-mid confirmbutton"
                                    [matTooltipDisabled]="currentUser?.hasAdminAccess || currentUser?.hasPurchaseAccess"    
                                    matTooltip="Requires Purchasing Permissions"
                                    (click)="confirmTransition(transition, TransitionType.TRANSITION_ONLY)"
                                  >Upgrade</button>
                                </td>
                              </tr>
                            </ng-container>
      
                          </tbody>
                        </table>
                      </div>
                      <div class="button-center">
                        <!--addonList and finishAddAddon method are not defined-->
                        <!-- <button *ngIf="addonList?.length && loadContent" class="button button-red button-large"
                          (click)="finishAddAddon()">Continue</button> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

          </form>
          <!-- view end dates right panel -->
          <ng-template #tempRef>
            <div id="sidecontainer">
              <child-header title="View subscription end-dates" (closeEvent)="sidenavService.panel.close()"></child-header>
              <div class="child-body">
                <p class="ml-3 view-end-date-title">This end date alignment must match with either one of the below subscriptions expiry date</p>
                <ng-container *ngFor="let s of subsForViewEndDates">
                  <div style="font-size: 11px; margin-left: 30px; cursor: pointer;" (click)="assignEndDate((nceRenewalPending || scheduledNextTermInstructions) ? scheduledNextTermInstructions?.customTermEndDate : s.baseSubscription.out_expiry_date)">
                    <span>Expiry Date: <span class="exp-date"> {{
                      (nceRenewalPending || scheduledNextTermInstructions) 
                        ? (scheduledNextTermInstructions?.customTermEndDate | date: 'dd/MM/yyyy') 
                        : (s.baseSubscription?.out_expiry_date | date: 'dd/MM/yyyy')
                    }}</span></span><br />
                    <span>{{ s.baseSubscription?.out_sub_description }}</span><br />
                    <span>{{ s.baseSubscription?.out_stk_description }}</span><br />
                    <span>SKU: {{ s.baseSubscription?.out_stock_code }}</span><br />
                  </div>
                  <br />
                </ng-container>
              </div>
            </div>
          </ng-template>  
        </div>

      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
